import { Injectable, Inject, isDevMode } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class AddTrackingService {
  constructor(@Inject(DOCUMENT) private document: Document) {}

  /**
   * Loads product tracking script.
   */
  loadTrackingScript(productTrackingUrl: string, quantivateProductId: string, ncUserId: string): void {

    const finalUrl = `${productTrackingUrl}/${quantivateProductId}/${ncUserId}.js`;

    try {
      const script = this.document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = finalUrl;

      script.onerror = (err) => {
        console.error('[addTracking] failed to load script:', finalUrl, err);
      };

      this.document.head.appendChild(script);
    } catch (err) {
      console.error('[addTracking] unexpected error while injecting script:', err);
    }
  }
}
